<template>
    <full-screen-overlay @close="exit" backTo="Dashboard">

        <dashboard-header header="Create new project" description="Projects are the websites or applications that you'll be creating a search database for..."/>

        <div class="w-full mt-8">
            <FormulateForm @submit="createProject" class="max-w-screen-xs">
                <label class="text-sm text-gray-500 leading-8" for="name">Project name...</label>
                <base-input autofocus required placeholder="Type name of project..." id="name" name="name" class="mb-6" />

                <base-button bgColor="bg-success dark:bg-green-600" borderColor="border-success dark:border-green-500" hoverBg="hover:bg-green-400 dark-hover:bg-green-500" hoverBorder="hover:border-success-400" class="mt-10" icon="project" iconPosition="left"   type="submit">Create Project</base-button>
            </FormulateForm>
        </div>

    </full-screen-overlay>
</template>

<script>
import { LayoutComponents } from '@/modules/Dashboard/components'
import { createProject, updateAuthenticationState } from "@/graphql/mutations";
import { authenticationState, loading, error, myProjects, me } from '@/mixins';

export default {
    name: "CreateProject",
    metaInfo: {
      title: 'New Project',
    },
    mixins: [LayoutComponents, authenticationState, loading, error, myProjects, me ],
    data () {
        return {
            isSubmitting: false,
            project: {
                name: ''
            }
        }
    },
    methods: {
        exit () {
            this.$router.push({ name: 'Project', params: { ...this.$route.params }, query: { ...this.$route.query } });
        },
        async createProject(data) {

            if (this.isSubmitting) {
                return;
            }

            this.isSubmitting = true;

            try {
                this.$root.$emit('loading', true);

                const project = await this.$apollo.mutate({
                    mutation: createProject,
                    variables: {
                        input: {
                            name: data.name
                        }
                    },
                });

                await this.$apollo.queries.me.refetch();
                await this.$apollo.queries.projects.refetch();

                await this.$apollo.mutate({
                    mutation: updateAuthenticationState,
                    variables: {
                        selectedProject: project.data.createProject.project.id
                    }
                });

                this.$router.push({ name: 'Project', params: { ...this.$route.params }, query: { ...this.$route.query, project: project.data.createProject.project.id } });

            } catch (error) {
                this.handleError(error);
            }

            this.$root.$emit('loading', false);

            this.isSubmitting = false;
        },
    }
}
</script>